export default __webpack_public_path__ + "static/media/logo.e587d973.svg";